import styled, { css } from 'styled-components';
import { Flex, FlexItem, media } from 'core/layout';

export const StyledSwiper = styled.div`
  position: relative;
  height: 100%;
  max-width: 800px;

  ${({ spaceBetween }) => spaceBetween && css`
    margin-top: -12px;

    ${media.tablet`
      margin-top: -8px;
    `};

    ${media.tabletSmall`
      margin-top: 0;
    `};
  `};
`;

export const Container = styled.div`
  height: 100%;

  ${({ spaceBetween }) => spaceBetween && css`
    margin: 0 -12px;

    ${media.tablet`
      margin: 0 -8px;
    `};

    ${media.tabletSmall`
      margin: 0;
    `};
  `};
`;

export const Wrapper = Flex.extend`
  align-items: stretch;
  margin-bottom: 0;

  ${({ spaceBetween }) => spaceBetween && css`
    padding: 12px;

    ${media.tablet`
      padding: 8px;
    `};

    ${media.tabletSmall`
      padding: 0;
    `};
  `};

  ${media.tablet`
    display: flex;
  `};
`;

export const Slide = FlexItem.extend`
  ${({ slidesPerView }) => slidesPerView ? css`
    flex: 0 0 ${(1 / slidesPerView) * 100}%;

    ${media.tablet`
      flex: 0 0 50%;
    `};

    ${media.tabletSmall`
      flex: 0 0 100%;
      padding: 4px;
    `};
  ` : `
    flex: 0 0 100%;
  `};

  height: auto !important;

  & > * {
    height: 100%;
    max-height: 90vh;
    object-fit: cover;
  }
`;

export const StyledNavigation = Flex.extend`
  justify-content: space-between;
  margin: 0 !important;
  & > * {
    padding: 0 !important;
  }
  @media (max-width: 480px) {
    ${({ marginStyle }) => marginStyle && css`
      margin-top: ${marginStyle}px !important;
    `};
  }

  ${({ overlayNav }) => overlayNav && css`
    position: absolute;
    top: 50%;
    left: 1rem;
    width: calc(100% - 2rem);
    z-index: 100;

    & > * {
      transform: translateY(-50%);
    }
  `};

  ${media.tablet`
    display: flex;
  `};
`;

export const NavigationButton = styled.div`
  &[aria-disabled="true"] {
    pointer-events: none;
    & > * {
      opacity: 0.35;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/Swiper/styled.js